module.exports = __webpack_public_path__ + "static/img/datarec.2482cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/datarec.png
// module id = 478
// module chunks = 1